import { jsxs as c, jsx as i } from "react/jsx-runtime";
import { useChatbotContext as x } from "../../hooks/useChatbotContext.js";
import { useMemo as w } from "react";
import { BotButton as u } from "./BotButton.js";
import { messageHasKeywords as M } from "../../utils/messageHasKeywords.js";
import { CalendarIcon as v } from "./CalendarIcon.js";
import { icons as g } from "lucide-react";
function T({ message: n, ...d }) {
  var l;
  const { chatbot: o, cn: p, messages: a } = x(), [h, m] = w(() => {
    const e = a.findIndex((r) => r.id === n.id), [t, ...f] = a.slice(0, e).filter((r) => r.role === "user"), s = f.pop() || t;
    return [(t == null ? void 0 : t.id) === (s == null ? void 0 : s.id), (r) => r.triggerCondition === "after_keyword" && s && M(
      s.content,
      r.triggerKeywords ?? []
    )];
  }, [n.id, a]);
  return /* @__PURE__ */ c(
    "div",
    {
      ...d,
      className: p(
        "mt-3 flex flex-row items-center gap-x-2.5 text-[13px] font-semibold leading-[1.21] empty:hidden",
        {
          "ml-0 @notMobile:ml-10": o == null ? void 0 : o.avatarUrl
        },
        d.className
      ),
      children: [
        o == null ? void 0 : o.buttons.map((e) => {
          const t = e.buttonIconName ? g[e.buttonIconName] : () => /* @__PURE__ */ i(
            "svg",
            {
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              height: 16,
              width: 16,
              children: /* @__PURE__ */ i(
                "path",
                {
                  fill: "currentColor",
                  d: "M9 23.66 20.54 9.91H15V.16L3.46 13.91H9v9.75Z"
                }
              )
            }
          );
          return e.triggerCondition === "after_every_chatbot_response" || m(e) ? /* @__PURE__ */ c(u, { button: e, message: n, children: [
            /* @__PURE__ */ i(t, { className: "h-4 w-4" }),
            e.buttonText
          ] }) : void 0;
        }),
        (l = o == null ? void 0 : o.scheduleButtons) == null ? void 0 : l.map((e) => {
          const t = e.buttonIconName ? g[e.buttonIconName] : v;
          return e.triggerCondition === "beginning_of_conversation" && h || m(e) ? /* @__PURE__ */ c(
            u,
            {
              button: e,
              message: n,
              label: `${e.buttonText} button`,
              children: [
                /* @__PURE__ */ i(t, { className: "h-4 w-4" }),
                e.buttonText
              ]
            }
          ) : void 0;
        })
      ]
    }
  );
}
export {
  T as BotMessageActions
};
